import { QueryClient } from "@tanstack/react-query";

/**
 * Shared TanStack Query client for all REST reads in apps/web.
 *
 * This is the web data layer for server REST state (see CLAUDE.md
 * "Client Data Fetching"): components should read API data via useQuery
 * so identical requests are deduped/cached app-wide instead of each
 * component running its own fetch()-in-useEffect. Jotai remains the store
 * for client/canvas state; Convex/Liveblocks/BroadcastChannel realtime
 * channels are separate transports and must not be routed through this.
 *
 * Defaults mirror apps/mobile/lib/query-client.ts. refetchOnWindowFocus
 * and refetchOnMount are off to match the app's pre-existing
 * "fetch once, stale until reload" behavior — opt in per-query where
 * freshness matters.
 */
export const webQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});
